import React from 'react';
import { motion } from 'framer-motion';
import LeftItems from '../../images/family-overview/overview-left-items.png';
import Co44 from '../../images/family-overview/co44.png';
import Co63 from '../../images/family-overview/co63.png';
import Co79 from '../../images/family-overview/co79.png';
import Co90 from '../../images/family-overview/co90.png';
import Co91 from '../../images/family-overview/co91.png';
import Co92 from '../../images/family-overview/co92.png';
import Co93 from '../../images/family-overview/co93.png';
import Co94 from '../../images/family-overview/co94.png';

export default function Overview() {
  const container = {
    /* ul animation */
    show: {
      transition: {
        delayChildren: 3.0,
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    /* li animation */
    hidden: { opacity: 0, y: -10 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <div className="family-overview-subpage" id="overview">
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.6 }}
        src={LeftItems}
        alt=""
        className="full-bg"
      />

      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 2 }}
        className="label"
      >
        Available in a variety of colors
      </motion.div>
      <motion.div
        id="device-wrapper"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.img variants={item} src={Co44} id="co44" />
        <motion.img variants={item} src={Co91} id="co91" />
        <motion.img variants={item} src={Co92} id="co92" />
        <motion.img variants={item} src={Co63} id="co63" />
        <motion.img variants={item} src={Co93} id="co93" />
        <motion.img variants={item} src={Co94} id="co94" />
        <motion.img variants={item} src={Co90} id="co90" />
        <motion.img variants={item} src={Co79} id="co79" />
      </motion.div>
    </div>
  );
}
